import React, { useEffect, useState } from "react";
import ProjectDetails from "../components/ProjectDetails/ProjectDetails";
import { vendorApi, api } from "../api/api";
import { render } from "@testing-library/react";
import ProjectPlotStructure from "../components/ProjectDetails/ProjectPlotStructure";
import ProjectImages from "../components/ProjectDetails/ProjectImages";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import CryptoJS from "crypto-js";
import { updateReferrerId } from "../redux/reducers/Reducer";
import { useDispatch } from "react-redux";
import ProjectDocument from "../components/ProjectDetails/ProjectDocument";
import ProjectLayoutPage from "../components/ProjectDetails/ProjectLayoutPage";
import RecentPropertiesList from "../components/RecentProperties/RecentPropertiesList";
import Loader from "../components/common/Loader";
import LoginModal from "../components/common/LoginModal";
import ScreenContainer from "../components/common/screencontainer";
import Description from "../components/common/Description";
import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
 
const ProjectDetailsScreen = () => {
  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const location = useLocation();
const [searchParams] = useSearchParams();
  const { slug } = useParams();
const projectId = slug?.split("-").pop();
const referralCode = searchParams.get("ref");

  
 
 
  const theme = useSelector((data) => data.themeValue.colors);
  // const { projectId } = location.state || {};
  // const [searchParams] = useSearchParams();
  const { type } = location.state || {};
 
  
 

 
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
 
 
 
  const dispatch = useDispatch();
  useEffect(() => {
  if ( referralCode) {
    const existingRef = localStorage.getItem("referralCode");

    if (!existingRef) {
      localStorage.setItem("referralCode", referralCode);
    }
  }
}, [referralCode]);

useEffect(() => {
  const applyReferral = async () => {
    const storedRef = localStorage.getItem("referralCode");

    if (!isAuthenticated || !storedRef || !projectId) return;

    // Prevent self referral
    if (storedRef == userId) {
      localStorage.removeItem("referralCode");
      return;
    }

    try {
      const fd = new FormData();
      fd.append("userId", userId);
      fd.append("refererId", storedRef);
      fd.append("projectId", projectId);

      const res = await vendorApi.addProjectUserMapping(fd);

      // console.log("Referral applied:", res);

      localStorage.removeItem("referralCode");
    } catch (error) {
      // console.error("Referral error:", error);
    }
  };

  applyReferral();
}, [isAuthenticated, userId, projectId]);
  
 useEffect(() => {
  const runEffect = async () => {
    try {
      const response = await vendorApi.getProjectById(projectId);
      if (response.status === 200) {
        setProjectData(response.data);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (projectId) {
    runEffect();
  }
}, [projectId]);


 
  const layoutConfig = [
    {
      id: "ProjectLayoutPage",
      render: () => <ProjectLayoutPage data={projectData} type={type} />,
    },
    {
      id: "ProjectPlotStructure",
      render: () => <ProjectPlotStructure data={projectData} type={type} isAuthenticated={isAuthenticated} />,
    },
    {
      id: "ProjectDescription",
      render: () => <Description data={projectData} />,
    },
    {
      id: "ProjectImages",
      render: () => <ProjectImages data={projectData} />
    },
    {
      id: "RecentProjects",
      render: () => <RecentPropertiesList userId={userId} type={1} propertyId={projectData?.id} />
    },
    // {
    //   id: "ProjectDocument",
    //   render: () => <ProjectDocument data={projectData.id} type={projectData.type} userId={userId} />
    // },
    // {
    //   id: "ProjectMap",
    //   render: () => <ProjectMap data={projectData} />
    // }
 
  ];
 
  // if (!isAuthenticated) {
  //   return (
  //     <LoginModal/>
  //   );
  // }
 
  return (
    <ScreenContainer>
      <Helmet>
      <title>
        {projectData?.project_name

          ? `${projectData.project_name}  in ${projectData.address} | Plots for Sale | JEMINS Builders & Developers Private Limited`
          : "Project Details | JEMINS Builders & Developers Private Limited"}
      </title>

      <meta
        name="description"
        content={
          projectData?.description
            ? projectData.description.substring(0, 160)
            : "Explore premium real estate projects with JEMINS Builders & Developers Private Limited."
        }
      />

      <meta property="og:type" content="website" />

      <meta
        property="og:title"
        content={projectData?.project_name || "JEMINS Builders & Developers Private Limited"}
      />

      <meta
        property="og:description"
        content={projectData?.description || ""}
      />

      <meta
        property="og:image"
        content={projectData?.images?.[0] || ""}
      />

      <meta
        property="og:url"
        content={window.location.href}
      />
    </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          padding: "5px"
        }}>
          {layoutConfig.map((section) => (
            <div
              key={section.id}
              style={{ backgroundColor: theme.background, ...styles.section }}
            >
              {section.render()}
            </div>
          ))}
        </Box>
      )}
    </ScreenContainer>
  );
 
};
 
const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    // padding: "10px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
 
  },
  heading: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "24px",
    color: "#333",
 
  },
  loadingText: {
    fontSize: "16px",
    color: "#555",
    textAlign: "center",
    marginTop: "40px",
 
  },
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
 
  },
 
};
 
export default ProjectDetailsScreen;